var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764214555872,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5556,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3 973.1c0.1-2.1-0.1-4.2 0.4-6.2 12.9-44.7 25.9-89.3 38.9-133.9 0.3-1.1 0.9-2.2 1.6-3.9 73.3 15.9 145.5 6.9 219-8.8-1 5.4-1.8 9.9-2.8 14.4-10.3 43.5-20.6 87-30.9 130.4-0.6 2.6-0.6 5.3-0.8 7.9-75.1 0.1-150.2 0.1-225.4 0.1zM688.2 468h-90.3v89.3H559c-13.2 0-26.5-0.5-39.6 0.2-7.4 0.4-10.3-1.9-12.1-9.2-19.2-76-38.9-151.8-58.4-227.7-0.7-2.9-1.6-5.7-3.9-8.7-3.6 14.9-7.3 29.7-10.8 44.6-15.1 64-30.3 127.9-45.1 192-1.6 7.1-4.5 9-11.4 8.9-51.7-0.3-103.3-0.1-155-0.1h-11.1v91.5h30.8v29.7h259.7c0.2 0.8 0.4 1.6 0.7 2.4-14.5 7.4-28.9 15-43.6 22.1-60.8 29.4-123.8 52.6-190.7 63.4-43.9 7.1-87.8 8.8-131.4-2.5-2.9-0.7-5.8-1.6-8.6-2.5-0.8-0.3-1.5-0.9-3.2-1.8 2.1-7.5 4.1-15.3 6.3-23C197 511.1 262.4 285.7 327.5 60.2c2-7 4.6-9.4 12.1-9.4 92.5 0.3 185.1 0.3 277.6 0 7.2 0 10.3 1.8 12.2 9.2 19 73.8 38.5 147.6 57.8 221.3 0.9 3.5 1.7 7.1 1.7 10.6 0.1 56.2 0.1 112.4 0 168.5-0.1 2.2-0.5 4.3-0.7 7.6z",
    fill: "#c0372f",
    "p-id": 5557
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M627.1 648.5H272.5v-29.4h-30.8v-31.5h386.1v-89.2h90.8V319.8h61.2v178.4h89.1V587h90.6v61.3h-90.2v88.1h-62.8c20.4 78 40.5 154.5 60.9 232.2-3.9 0.2-6.7 0.6-9.5 0.6-77.8 0-155.6-0.1-233.5 0.2-7.2 0-9.6-2.5-11.3-9.1-18.5-73-37.3-146-56.3-219-1.5-5.8-0.1-8.4 5-11.2 19.6-10.5 38.7-21.9 58.2-32.4 5.6-3.1 7.2-6.9 7-12.9-0.2-11.6 0.1-23.3 0.1-36.3z m178.7 26.6V558.5H691.3v116.6h114.5z",
    fill: "#c0372f",
    "p-id": 5558
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M779.3 648.3h-60.9v-60.4h60.9v60.4z",
    fill: "#c0372f",
    "p-id": 5559
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.6280c2cfabc8ecdf84f921ae9c28c6e0.svg";
export { ForwardRef as ReactComponent };